import axios from 'axios';
import { API_URL } from '../config/config';
import { getHeaderOptions } from './getHeaderOptions';

export interface OrganizationData {
  name: string;
  phone: string;
  countryCode?: string;
  currency: string;
  timeZone: string;
  website: string;
  address: string;
  description: string;
  socialLinks: {
    linkedin: string;
    twitter: string;
    facebook: string;
    instagram: string;
  };
  iconUrl: string;
  profileUrl: string;
  faviconUrl: string;
  isAutomationAutoTaskAssignEnable: boolean;
  isIntegrationDuplicateLeadAllow: boolean;
  supportContact: {
    phone: string;
    whatsapp: string;
    email: string;
  };
  taskNotificationOverdueDays: number;
  lastLeadSequenceId: string;
  isCallRecordingEnabled: boolean;
  address1: string;
  address2: string;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  gst: string;
  businessCategory?: string;
}

export interface PostalData {
  Name: string;
  District: string;
  State: string;
  Country: string;
  Pincode: string;
}

export interface PostalApiResponse {
  Message: string;
  Status: string;
  PostOffice: PostalData[] | null;
}

/**
 * Fetch organization data
 */
export const getOrganization = async () => {
  const headers = {
    ...getHeaderOptions(),
    Authorization: localStorage.getItem('auth_token') || ''
  };
  const response = await axios.get(`${API_URL}api/v1/organization`, { headers });
  return response.data;
};

/**
 * Update organization data
 */
export const updateOrganization = async (organizationId: string, data: Partial<OrganizationData>) => {
  const headers = {
    ...getHeaderOptions(),
    Authorization: localStorage.getItem('auth_token') || ''
  };

  // Filter out empty fields
  const filteredData = Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== '' && value !== null && value !== undefined) {
      if (typeof value === 'object' && !Array.isArray(value)) {
        const filteredNested = Object.entries(value).reduce((nestedAcc, [nestedKey, nestedValue]) => {
          if (nestedValue !== '' && nestedValue !== null && nestedValue !== undefined) {
            nestedAcc[nestedKey] = nestedValue;
          }
          return nestedAcc;
        }, {} as any);

        if (Object.keys(filteredNested).length > 0) {
          acc[key] = filteredNested;
        }
      } else {
        acc[key] = value;
      }
    }
    return acc;
  }, {} as any);

  const response = await axios.put(`${API_URL}api/v1/organization/${organizationId}`, filteredData, { headers });
  return response.data;
};

/**
 * Fetch postal data by PIN code
 */
export const getPostalData = async (pincode: string): Promise<PostalApiResponse[]> => {
  const response = await axios.get<PostalApiResponse[]>(`https://api.postalpincode.in/pincode/${pincode}`);
  return response.data;
};
